module.exports = __webpack_public_path__ + "static/media/departure-pin.25277336.svg";